export default __webpack_public_path__ + "media/charts-diagrams.4ccbd838904f7e2b9f5d53c9f78d6f59.svg";